<script setup lang="ts">
import { InterfaceSelection } from "~/classes/entity/InterfaceSelection"
import { ReactiveFile } from "~/classes/file/ReactiveFile"

defineProps({
  searchId: null
})

const { files, loaded, errored, unwatch } = ReactiveFile.createReactiveSearchList(
  __props.searchId,
  "sidebar",
  InterfaceSelection.minimumPathSelection(),
)

const rankedFolders = computed(() => Object
  .values(files.value)
  .sort((a, b) => (b.searchResult()?.rank ?? 0) - (a.searchResult()?.rank ?? 0)),
)

onUnmounted(() => {
  unwatch()
})
</script>

<template>
  <div v-if="loaded" class="entry-search-list">
    <sidebar-entry-file
      v-for="file in rankedFolders"
      :key="file.id"
      :file
      class="entry-search-list-item"
    />
  </div>
  <div v-else-if="errored" class="entry-search-errored">
    An error occurred
  </div>
  <div v-else class="entry-search-loading">
    <span>Loading</span>
    <interface-dots />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.entry-search-list
  @apply pl-[#{$sidebar-pl-indent}]

.entry-search-errored
  @apply text-[#{$global-red-primary}] t-panel-sm // TODO boltzmann
  @apply inline-flex items-center
  @apply gap-1

.entry-search-loading
  @apply text-[#{$global-t-secondary}] t-panel-sm // TODO boltzmann
  @apply inline-flex items-center
  @apply gap-1

.entry-search-list-item
  @apply mt-[#{$sidebar-gap-content-section}]
</style>
